import notFoundPageImage from 'assets/images/404-pic.svg';
import notFoundPageText from 'assets/images/404-text.svg';
import 'assets/css/style.css';

function NotFoundPage() {
  return (
    <article className="text-center system-page">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6">
          <img src={notFoundPageText} alt="" />
          <br />
          <a href="/">
            <i className="lnr lnr-arrow-left-circle margin-right" />
            {translate('Back to Home page')}
          </a>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6">
          <img src={notFoundPageImage} alt="" />
        </div>
      </div>
    </article>
  );
}

// eslint-disable-next-line import/no-default-export
export default NotFoundPage;
